import React, { useState } from 'react';
import MDTypography from 'components/MDTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import {
  Loader,
  AnnouncementsWrapper,
  LinkWrapper,
  TitleTypography,
  TimeOutGrid,
  ButtonWrapper,
  ButtonSpinner,
  ButtonSpinnerProgress,
  HeadingGrid,
} from 'components/Ui/styled';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import LoadingSpinner from 'components/Loader/LoadingSpinner';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { PaperProps } from 'constants';
import {
  setIsLogoutTiming,
  resetIsLogout,
} from 'examples/Navbars/store/logoutSlice';
import { Provider, useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import NotificationMessagePopup from 'components/Common/NotificationMessagePopup';
import { format } from 'date-fns';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Authenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { MaterialUIControllerProvider } from 'context';
import { store } from 'redux/store';
import { weekendDaysMessage, weekDaysMessage } from '../../src/constants';
import { NoInfoGrid } from 'components/Ui/styled';
import { TypographyText } from 'components/Ui/styled';
const { default: themeRtl } = require('assets/theme/theme-rtl');

export const renderComponent = (component) => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {component}
    </DashboardLayout>
  );
};

export const ListItems = (props) => {
  const { title } = props;
  return (
    <AnnouncementsWrapper>
      <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
        <FiberManualRecordRoundedIcon />
      </MDTypography>
      <TitleTypography>{title}</TitleTypography>
    </AnnouncementsWrapper>
  );
};

export const showLoader = () => (
  <Loader data-testid="loading">
    <LoadingSpinner />
  </Loader>
);

export const LinkItems = (props) => {
  const { title } = props;
  return (
    <LinkWrapper>
      <MDTypography variant="body1" color="secondary" lineHeight={0.75}>
        <FiberManualRecordRoundedIcon />
      </MDTypography>
      <TitleTypography>{title}</TitleTypography>
    </LinkWrapper>
  );
};

export const getYesNo = (handleNo, handleYes, loading) => {
  return (
    <ButtonWrapper container>
      <Button variant="text" onClick={handleNo}>
        No
      </Button>
      <ButtonSpinner>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button variant="text" onClick={handleYes} disabled={loading}>
            Yes
          </Button>
          {loading && <ButtonSpinnerProgress size={24} />}
        </Box>
      </ButtonSpinner>
    </ButtonWrapper>
  );
};

export const TimeOutPopup = ({ seconds, setSeconds, signOut }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLogoutTiming = useSelector((state) => state.logout.isLogoutTiming);
  const handleYes = () => {
    dispatch(setIsLogoutTiming(false));
    setSeconds(60);
  };

  const handleNo = () => {
    dispatch(setIsLogoutTiming(false));
    setSeconds(60);
    navigate('/');
    signOut();
    setTimeout(() => {
      dispatch(resetIsLogout());
    }, 2000);
  };

  return (
    <Dialog open={isLogoutTiming} PaperProps={PaperProps}>
      <TimeOutGrid container>
        <Typography variant="h6">
          Your session will expire in {seconds} seconds. Do you want to extend
          the session ?
        </Typography>
      </TimeOutGrid>
      {getYesNo(handleNo, handleYes)}
    </Dialog>
  );
};

export const renderHeading = (title, buttonText, handleClick) => {
  return (
    <HeadingGrid container>
      <MDTypography variant="h5" fontWeight="medium" data-testid={title}>
        {title}
      </MDTypography>
      <Button onClick={handleClick} variant="text">
        {buttonText}
      </Button>
    </HeadingGrid>
  );
};

export const renderSaveButton = (buttonText, handleSubmit, loading) => {
  return (
    <ButtonWrapper container>
      <ButtonSpinner>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button variant="text" onClick={handleSubmit} disabled={loading}>
            {buttonText}
          </Button>
          {loading && <ButtonSpinnerProgress size={24} />}
        </Box>
      </ButtonSpinner>
    </ButtonWrapper>
  );
};

export const formatDateString = (date) => {
  const originalDate = new Date(date);
  const year = originalDate.getFullYear();
  const month = String(originalDate.getMonth() + 1).padStart(2, '0');
  const day = String(originalDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const showBackdropLoader = (isLoading) => (
  <Backdrop
    sx={{ color: '#ffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isLoading}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export const useBackdropLoader = () => {
  const [isBackdropLoading, setIsBackdropLoading] = useState(false);

  const BackdropLoader = () => {
    return (
      <Backdrop
        sx={{ color: '#ffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isBackdropLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  return { setIsBackdropLoading, BackdropLoader };
};

export const useNotification = () => {
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const handleErrorResponse = (notificationMessage) => {
    setOpenNotification(true);
    setNotificationMessage(notificationMessage);
  };

  const NotificationPopup = (props) => {
    const { setOpenConfirmationDialog } = props;
    return (
      <NotificationMessagePopup
        openPopUp={openNotification}
        message={notificationMessage}
        setNotificationMessage={setNotificationMessage}
        setOpenNotification={setOpenNotification}
        setOpenConfirmationDialog={setOpenConfirmationDialog}
      />
    );
  };

  return {
    openNotification,
    notificationMessage,
    setOpenNotification,
    setNotificationMessage,
    NotificationPopup,
    handleErrorResponse,
  };
};

export const formatMMDDYYYY = (date) => {
  const formattedDate = format(new Date(date), 'MM-dd-yyyy');
  return formattedDate;
};

export const renderButton = (buttonText, handleSubmit, disabled) => {
  return (
    <ButtonWrapper container>
      <Button variant="text" onClick={handleSubmit} disabled={disabled}>
        {buttonText}
      </Button>
    </ButtonWrapper>
  );
};

export const testComponent = (component) => {
  return (
    <Authenticator.Provider>
      <Provider store={store}>
        <BrowserRouter>
          <MaterialUIControllerProvider>
            <ThemeProvider theme={themeRtl}>
              <CssBaseline />
              {component}
            </ThemeProvider>
          </MaterialUIControllerProvider>
        </BrowserRouter>
      </Provider>
    </Authenticator.Provider>
  );
};

export const getTimeSlotMessage = (timeSlots, isInfo, isSlots) => {
  return timeSlots?.length < 1 || !isInfo || isSlots
    ? weekendDaysMessage
    : weekDaysMessage;
};

export const hasNoSlotsForDay = (timeSlots) => {
  return timeSlots?.length > 0 && timeSlots?.every((slot) => !slot?.available);
};

export const formatDateUTCString = (date) => {
  if (!date) return '';
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    return date.substring(0, 10);
  }
  const originalDate = new Date(date);
  const year = originalDate.getFullYear();
  const month = String(originalDate.getMonth() + 1).padStart(2, '0');
  const day = String(originalDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const handleBooleanProp = (booleanValue) =>
  booleanValue ? 1 : undefined;

export const getAuthHeaders = async () => {
  const { tokens } = await fetchAuthSession();
  return { Authorization: `Bearer ${tokens?.accessToken?.toString()}` };
};

export const useRenderNoInfo = (data, message) => {
  if (data?.length === 0) {
    return <NoInfoGrid container>
      <TypographyText>{message}</TypographyText>
    </NoInfoGrid>;
  }
  return null;
};